import { render, staticRenderFns } from "./_picker.vue?vue&type=template&id=5c752b1c&"
import script from "./_picker.vue?vue&type=script&lang=js&"
export * from "./_picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports